<template>
    <div class="page">
        <slot />
    </div>
</template>

<script>
  export default {
    name: 'Page',
    computed: {
      darkTheme() {
        return this.$store.state.system.theme === 'dark';
      },
    },
  };
</script>

<style scoped lang="scss">
    .page {
        height: 100%;
        overflow-y: auto;
        padding: 30px;

        &::-webkit-scrollbar {
            width: 0;
            background: transparent;
        }
    }
</style>
